<template>
  <div ref="lastArticlesHeader" class="lastArticlesContainer">
    <v-toolbar class="categoriesHeader" elevation="0"
    >
      <v-icon @click="goBack">
        mdi-chevron-left
      </v-icon>

      <v-toolbar-title class="pageTitle">
        Inventur abschließen
      </v-toolbar-title>

    </v-toolbar>
    <v-divider class="headerDivider"/>

    <div class="contentWrapper checkoutContent" ref="contentWrapper" id="contentWrapper" v-if="!isLoading">
      <v-card>
        <v-container class="checkoutDetailsWrapper">
          <span></span>

          <span>Gesamtbetrag:</span>
          <span>{{ this.getInventoryTotal.totalPrice | parsePrice2Digits }} €</span>
          <v-skeleton-loader type="text" class="totalPriceCheckoutSkeleton" v-if="isLoading"></v-skeleton-loader>
          <span>netto & ggf. zzgl. Pfand</span>
        </v-container>
      </v-card>

      <v-dialog
          v-model="depositDialog"
          scrollable
          persistent
          content-class="inventory-deposit-dialog"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
              color="primary"
              dark
              v-bind="attrs"
              v-on="on"
              class="add-deposit-inventory_btn"
          >
            Pfand hinzufügen
          </v-btn>
        </template>

        <v-card class="depositListCard">
          <v-container class="depositListContainer" v-if="!isLoading">
            <table>
              <thead>
              <td>
                <b>Pfandtyp</b>
              </td>

              <td>
                <b>Anzahl</b>
              </td>
              </thead>
              <tbody>
              <tr v-for="depositItem in depositValues"
                  :key="depositItem.itemNo">
                <td>
                    <span>
                      {{ depositItem.description }}
                      <br>
                      {{ depositItem.itemNo }}
                    </span>
                </td>
                <td>

                  <v-text-field class="searchCbx depositListInput"
                                rounded
                                dense
                                outlined
                                type="number"
                                :value="getDepositContent(depositItem.itemNo)"
                                @blur="updateInventory(depositItem, $event.target.value)"
                  >

                  </v-text-field>

                </td>
              </tr>
              </tbody>
            </table>
          </v-container>
        </v-card>
        <v-btn
            @click="depositDialog = !depositDialog"
            class="close-btn-deposit-inventory"
        >
          <span>Schließen</span>
        </v-btn>
      </v-dialog>

      <v-btn
          class="sent-inventory_btn"
          @click="issueInventory"
          :disabled="this.getInventoryTotal.data.length === 0"
      >
        <Component :is="require(`@/assets/inventory/inventoryIconWhite.svg`)" class="mr-2"/>
        <span>Inventur abschließen</span>
      </v-btn>

      <v-dialog v-model="depositCheck" max-width="400" content-class="inventory-dialog">
        <div class="inventory-dialog_wrapper">
        <v-card class="inventory-dialog__card">
          <v-card-title>
            Pfandartikel hinzufügen?
          </v-card-title>

          <v-card-text>
            Möchtest Du deiner Inventurliste noch Pfandartikel hinzufügen?
            <br>
            Wenn ja, dann drücke einfach auf "Pfand eingeben".
            <br>
            Wenn nein, dann kannst Du deine Inventur einfach abschicken.
          </v-card-text>
        </v-card>

        <v-btn class="inventory-dialog_btn-left" @click="openDepositFromDialog">
          Pfand eingeben
        </v-btn>

        <v-btn class="inventory-dialog_btn-right" @click="finishInventory"
               :disabled="this.getInventoryTotal.data.length === 0"
        >
          Abschicken
        </v-btn>
        </div>
      </v-dialog>

      <v-expansion-panels class="checkoutCartOverview"
                          flat accordion
      >
        <v-expansion-panel>
          <v-expansion-panel-header>
            Details zur Inventurliste
          </v-expansion-panel-header>
          <v-divider/>
          <v-expansion-panel-content>
            <v-virtual-scroll class="inventory-total-list_v-scroll" item-height="181"
                              bench="5"
                              :items="this.getInventoryTotal.data"
                              v-if="!isLoading && this.getInventoryTotal !== null"
            >
              <template v-slot:default="{index, item}">
                <v-card class="article-card_no-img-full-borders" :key="index">
                  <div class="article-card__desc-no-img">
                    {{ item.description }}
                  </div>
                  <div class="article-card__itemNo-no-img">
                    Artikelnummer: {{ item.itemNo }}
                  </div>
                  <div class="article-card__ordered-type-no-img">
                    {{ item.amount }} {{ item.unit | capitalize}}
                  </div>
                  <div class="article-card__price-no-img">
                        <span class="total-price">
                          {{ item.price | parsePrice2Digits }} €
                        </span>
                    <span class="single-price">
                          Einzelpreis: {{ item.singlePrice | parsePrice2Digits }} €
                        </span>
                  </div>
                </v-card>
                <v-btn class="v-scroll_btn-delete" @click="removeFromInventoryList(item, index)">
                  <TrashCan/>
                </v-btn>
              </template>

            </v-virtual-scroll>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="bottomFiller"/>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import router from "@/router";
import TrashCan from "@/assets/cart/trashCan";
import axios from "axios";
export default {
  name: "inventoryCheckout",
  components: {TrashCan},
  data() {
    return {
      isLoading: true,
      depositValues: null,
      depositDialog: false,
      depositCheck: false
    }
  },

  methods: {
    ...mapActions('inventory', {
      getDepositValues: 'getDepositValues',
      addArticleToInventory: 'addArticleToInventory',
      removeFromInventory: 'removeFromInventory',
      issueInventory: 'issueInventory',
      fetchTotalInventory: 'fetchTotalInventory',
      fetchPersonalInventory: 'fetchPersonalInventory'
    }),

    ...mapActions({
      setHeaderVisibility: 'setHeaderVisibility',
      setLoadingState: 'setLoadingState'
    }),


    ...mapMutations('inventory', {
      setInventoryAvailable: 'setInventoryAvailable',
      setInventoryMode: 'setInventoryMode'
    }),

    goBack() {
      router.go(-1)
    },

    openDepositFromDialog() {
      this.depositCheck = false
      setTimeout(() => {
        this.depositDialog = true
      }, 150)
    },

    issueInventory() {
      this.depositCheck = true
    },

    finishInventory() {
      axios.get('api/issueInventory').then(() => {
        this.setInventoryAvailable(false)
        this.setInventoryMode(false)
        router.push({name: 'LastArticle'})
      })
    },

    updateInventory(item, amount) {

      const dataForStore = {amount: amount,
        description: item.description,
        itemNo: item.itemNo,
        price: item.price !== 0 ? item.price.price * amount : 0,
        singlePrice: item.price !== 0 ? item.price.price : 0,
        type: 's',
        unit: item.packageUnit,
        uid: this.getUserId
      }

      let params = {
        artNr: item.itemNo,
        amount: amount,
        type: 's',
        dataForStore: dataForStore
      }

      this.addArticleToInventory(params)
    },

    getDepositContent(itemNo) {
      let amount = this.getInventoryTotal.data.filter(el => {
        if(el.itemNo === itemNo) {
          return el.amount
        }
      })

      if(amount.length > 0) {
        return amount[0].amount
      }
    },

    removeFromInventoryList(item) {

      const params = {
        itemNo: item.itemNo,
        type: item.type,
        uid: item.uid
      }

      this.removeFromInventory(params)

    }
  },

  computed: {
    ...mapGetters({
      getUserId: 'getUserId'
    }),

    ...mapGetters('inventory', {
      getInventoryTotal: 'getInventoryTotal'
    }),

    isDepositSet() {
      if(this.depositValues !== null && this.getInventoryTotal !== null && this.isLoading === false) {
        let depositCheck = false
        this.depositValues.forEach(el => {
          this.getInventoryTotal.data.filter(invEl => {
            if(invEl.itemNo === el.itemNo) {
              depositCheck = true
            }
          })
        })
        return depositCheck
      }
      else {
        return false
      }
    }
  },

  mounted() {
    this.setHeaderVisibility(false)
    this.getDepositValues().then((res) => {
      this.depositValues = res.data
    })

    this.fetchTotalInventory().then(() => {
      this.fetchPersonalInventory()
      this.isLoading = false
    })

    new Promise((resolve) => {
      this.fetchPersonalInventory()
      this.fetchTotalInventory()
      resolve(true)
    }).then(() => {
      this.isLoading = true
    })
  }
}
</script>

<style>

.inventory-total-list_v-scroll {
  margin-top: 4px;
}

.article-card_no-img-full-borders {
  border-radius: 30px!important;
  height: 169px;
  width: 100%;
  display: grid;
  grid-template-columns: auto;
  grid-template-rows: 33px 39px 33px 40px;
  background-color: white;
  border-radius: 30px;
  overflow: hidden;
  padding: 12px 16px;
}

.inventory-deposit-dialog {
  border-radius: 30px!important;
  background-color: white;
  border: 3px solid white;
  max-width: 700px!important;
}

.inventory-deposit-dialog .depositListContainer {
  display: grid!important;
}


@media all and (max-width: 700px) {
  .close-btn-deposit-inventory {
    position: fixed;
    background-color: var(--igros-red) !important;
    right: 35px;
    bottom: calc((100vh * 0.1) / 2 - 22px);
    width: 100px;
  }
}
@media all and (min-width: 701px) {
  .close-btn-deposit-inventory {
    position: fixed;
    background-color: var(--igros-red) !important;
    right: calc((100vw - 700px) / 2 + 15px);
    bottom: calc((100vh * 0.1) / 2 - 22px);
    width: 100px;
  }
}

.add-deposit-inventory_btn {
  float: right;
  margin-bottom: 15px;
  margin-top: 20px;
  height: 44px!important;
}

.sent-inventory_btn {
  float: right;
  margin-bottom: 15px;
  margin-left: 100%;
  height: 44px!important;
  background-color: var(--igros-red) !important;

}

.v-scroll_btn-delete {
  height: 50px!important;
  min-width: 50px!important;
  width: 50px;
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.inventory-dialog_btn-left {
  background-color: var(--igros-slightgrey)!important;
  position: relative;
  top: -22px;
  left: -35px;
}

.inventory-dialog_btn-right {
  background-color: var(--igros-red)!important;
  position: relative;
  top: -22px;
  right: -35px;
}

.v-sheet.inventory-dialog__card {
  padding: 15px 15px 40px 15px;
  text-align: left;
}

.inventory-dialog {
  box-shadow: none!important;
}

</style>
